module.exports = __webpack_public_path__ + "static/media/facebook.507c6de4.svg";